// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DataProperty extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  dataPropertyId!: number;
  createdAt!: Date;
  createdBy!: string;
  datatype!: number;
  deleted!: boolean;
  lookupListCategoryId?: number;
  lookupListKey?: number;
  updatedAt!: Date;
  updatedBy!: string;
  value?: string;
  version!: any;
}

